import { render, staticRenderFns } from "./UrlPage.vue?vue&type=template&id=5843e67b&scoped=true"
import script from "./UrlPage.vue?vue&type=script&lang=js"
export * from "./UrlPage.vue?vue&type=script&lang=js"
import style0 from "./UrlPage.vue?vue&type=style&index=0&id=5843e67b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843e67b",
  null
  
)

export default component.exports